exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container {\n  height: 50px;\n  /* padding-left: 50px;\n    padding-top: 15px;\n    padding-right: 50px;\n    padding-bottom: 15px; */\n}\n.header-menu {\n  font-weight: 500;\n  color: white;\n  padding-top: 10px;\n}\n.logo {\n  font-size: 23px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/components/views/Main.css
// module id = 118
// module chunks = 0